import { Box } from '@mui/material'
import utils from 'helpers/utils'
import useEffectOnce from 'hooks/useEffectOnce'
import useShowError from 'hooks/useShowError'
import axios from 'providers/axios'
import { useState } from 'react'

type Props = {
  productId: string
  invitedById?: string
}

type ProductReview = {
  id: string
  name: string
  nameFile?: string
  user?: {
    id: string
    name: string
  }
}

const SignUpProductReviewer = (props: Props) => {
  const showError = useShowError()

  const [productReview, setProductReview] = useState<ProductReview | null>(null)

  useEffectOnce(() => {
    const fetchProduct = async () => {
      try {
        let url = `/sign-up/reviewer/${props.productId}`
        if (props.invitedById) url += `?invitedById=${props.invitedById}`
        const { data } = await axios.get(url)
        console.log(data)
        setProductReview(data)
      } catch (error) {
        showError(error)
      }
    }

    fetchProduct()
  })

  if (!productReview) return null

  return (
    <Box textAlign="center">
      {productReview.nameFile && (
        <img
          src={utils.getUrlFileMedia(productReview.nameFile)}
          alt={productReview.name}
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '18px',
            border: '1px solid var(--black)',
            marginBottom: '24px',
          }}
        />
      )}

      <Box fontSize="21px">
        <h3 className="m-0 text-dark-blue">
          {productReview.user ? <>{productReview.user?.name} is inviting you to</> : 'Sign up to'}
        </h3>
        <h3 className="m-0 text-blue">review {productReview.name}</h3>
      </Box>
    </Box>
  )
}

export default SignUpProductReviewer
